import { put, call, all, takeLatest } from 'redux-saga/effects';
import { axiosInstance } from '../../../utils/axios/axios-instance';
import * as actions from './actions';
import { API_ENDPOINTS } from '../../../config/api-endpoints';

function* getSummaryList(action: ReturnType<typeof actions.getSummaryList.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.DAILY_REPORT.Summary, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getSummaryList.success((response as any).data));
  } catch (err) {
    yield put(actions.getSummaryList.failure(err));
  }
}

function* getDetailList(action: ReturnType<typeof actions.getDetailList.request>): Generator {
  try {
    const { filter, sort, pagination } = action.payload;
    const response = yield call(axiosInstance.get, API_ENDPOINTS.DAILY_REPORT.Details, {
      params: { sort, ...filter, ...pagination },
    });

    yield put(actions.getDetailList.success((response as any).data));
  } catch (err) {
    yield put(actions.getDetailList.failure(err));
  }
}

// Main saga
export default function* dailySaga() {
  yield all([
    takeLatest(actions.getSummaryList.request, getSummaryList),
    takeLatest(actions.getDetailList.request, getDetailList),
  ]);
}
